import React from "react";
import { history } from "../../store/store";
import PropTypes from "prop-types";
import { withFormik } from "formik";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { apiClient } from "../../api/apiClient";
import SignInContainer from "../SignInContainer/SignInContainer";
import { logoutUser } from "../../modules/user/userActions";
import { withCurrentAccount } from "../../modules/accounts/accountHocs";
import { Typography } from "@mui/material";

// Converted styles to MUI v5 `sx` props on components below.

const NewPasswordValidationScheme = Yup.object().shape({
  currentPassword: Yup.string().required(),
  newPassword: Yup.string().required(),
});

// Wrap our form with the using withFormik HoC
const formControl = {
  // Transform outer props into form values
  mapPropsToValues: (props) => ({
    currentPassword: "",
    newPassword: "",
  }),
  // Add a custom validation function (this can be async too!)
  validationSchema: NewPasswordValidationScheme,
  // Submission handler
  handleSubmit: async (
    values,
    { props, setSubmitting, setErrors, resetForm },
  ) => {
    const { currentPassword, newPassword } = values;
    const { accountId } = props.currentAccount;

    try {
      await apiClient().post(`/accounts/${accountId}/_updatePassword`, {
        currentPassword,
        newPassword,
      });
      // log user out
      props.dispatch(logoutUser());
      history.push(SignInContainer);
    } catch (err) {
      console.error(err);
    }
    resetForm();
  },
};

const UpdatePasswordForm = (props) => {
  const { values, handleChange, handleSubmit, touched, errors } = props;

  const { formatMessage } = props.intl;

  return (
    <React.Fragment>
      <Box
        component="main"
        sx={(theme) => ({
          paddingTop: theme.spacing(16),
          marginLeft: theme.spacing(3),
          marginRight: theme.spacing(3),
        })}
      >
        <Paper
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pt: 2,
            px: 3,
            pb: 3,
          }}
        >
          <Typography variant="h5">Neues Passwort</Typography>

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ width: "100%", mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="currentPassword"
              name="currentPassword"
              label={formatMessage({ id: "app.reset.currentPassword" })}
              type="password"
              value={values.currentPassword}
              onChange={handleChange}
              autoComplete="current-password"
              autoFocus
              error={Boolean(touched.currentPassword && errors.currentPassword)}
              helperText={
                touched.currentPassword && errors.currentPassword
                  ? errors.currentPassword
                  : ""
              }
            />

            <TextField
              required
              fullWidth
              id="newPassword"
              name="newPassword"
              label={formatMessage({ id: "app.reset.newPassword" })}
              type="password"
              value={values.newPassword}
              onChange={handleChange}
              autoComplete="new-password"
              error={Boolean(touched.newPassword && errors.newPassword)}
              helperText={
                touched.newPassword && errors.newPassword
                  ? errors.newPassword
                  : ""
              }
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              color="secondary"
              sx={{ mt: 3 }}
            >
              {formatMessage({ id: "app.reset.action.changePassword" })}
            </Button>
          </Box>
        </Paper>
      </Box>
    </React.Fragment>
  );
};

UpdatePasswordForm.propTypes = {
  intl: PropTypes.object.isRequired,
};

export default compose(
  withCurrentAccount(),
  connect(),
  withRouter,
  injectIntl,
  withFormik(formControl),
)(UpdatePasswordForm);
